import BaseReport from '@/store/modules/BaseReport'

export default class Departments extends BaseReport {
    constructor() {
        const reportUrl = '/backend/orgs/departments/'
        super(reportUrl)

        this.actions.getOne = async function (ctx, id) {
            const url = `${reportUrl}${id}/`
            const method = 'get'
            return await BaseReport.makeRequest({method, url})
        }
    }
}
